const knowledgeLibrary = [
  {
    path: '/knowledgeLibrary',  // 知识库
    name: 'KnowledgeLibrary',
    component: () => import('@/pages/knowledgeLibrary/index.vue'),
  },
  {
    path: '/knowledgeLibrary/library/:id',  // 知识库 专题知识列表
    name: 'Library',
    component: () => import('@/pages/knowledgeLibrary/library/index.vue'), 
  },
  {
    path: '/knowledgeLibrary/libraryInfo/:id',//  知识库介绍
    name: 'LibraryInfo',
    component: () => import('@/pages/knowledgeLibrary/library/libraryInfo/index.vue')
  },
  {
    path: '/knowledgeLibrary/knowledgeInfo/:id',  // 知识库 专题知识列表
    name: 'KnowledgeInfo',
    component: () => import('@/pages/knowledgeLibrary/knowledgeInfo/index.vue'), 
  },
  {
    path: '/knowledgeLibrary/myKnowledge',//  我投稿的知识
    name: 'myKnowledge',
    component: () => import('@/pages/knowledgeLibrary/myKnowledge/index.vue')
  },

  {
    path: '/knowledgeLibrary/myKnowledge/detail',//  我投稿的知识--查看
    name: 'myKnowledgeDetail',
    component: () => import('@/pages/knowledgeLibrary/myKnowledge/detail.vue')
  },
  {
    path: '/knowledgeLibrary/login',  // 知识库
    name: 'KnowledgeLibraryLogin',
    component: () => import('@/pages/knowledgeLibrary/login/index.vue'),
  },
]
export default knowledgeLibrary


// WEBPACK FOOTER //
// ./src/router/modules/knowledgeLibrary.js